
function ImageRow({report, row, index, onHide}){
    return <tr onClick={() => onHide(index)}>
        <td>
           <img src={row.src} />
        </td>
    </tr>;
}
export default ImageRow;